import React, { useState, useEffect } from 'react'
import { FaEdit } from 'react-icons/fa'
import GuideContentDisplay, { InteractionRow } from './GuideContentDisplay'
import { ContentType } from '../../utils/enums'
import Drawer from '../common/Drawer'

const GuideFullLayout = ({
  guide,
  user,
  userInteraction,
  interactionLoading,
  handleLike,
  handleDislike,
  activeSection,
  handleGuideContentsClick,
  contentsVisible,
  setContentsVisible,
  showContentsSidebar,
  isAuthor,
  handleEdit
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [drawerOpen, setDrawerOpen] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  if (!guide) return null
  const contents = (
    <div className={`guide-contents ${contentsVisible ? '' : 'hidden'}`}>
      {!isMobile && <h2>Contents</h2>}
      <ol>
        <li className={activeSection === 'introduction' ? 'active' : ''}>
          <a href="#introduction" onClick={e => { handleGuideContentsClick(e, 'introduction'); if(isMobile) setDrawerOpen(false) }}>Introduction</a>
        </li>
        {guide.days.map(day => (
          <li key={day.day_number} className={activeSection === `day-${day.day_number}` ? 'active' : ''}>
            <a href={`#day-${day.day_number}`} onClick={e => { handleGuideContentsClick(e, `day-${day.day_number}`); if(isMobile) setDrawerOpen(false) }}>
              {day.subtitle}
            </a>
          </li>
        ))}
      </ol>
    </div>
  )
  return (
    <div className="guide-detail-wrapper guide-wrapper">
      {showContentsSidebar && !isMobile && (
        <aside className="contents-sidebar" id="contents-section">
          <button
            className="toggle-contents-button"
            aria-expanded={contentsVisible}
            aria-controls="contents-section"
            onClick={() => setContentsVisible(!contentsVisible)}
          >
            {contentsVisible ? (
              <>
                <FaEdit style={{ visibility: 'hidden' }} /> Hide Contents
              </>
            ) : (
              <>
                <FaEdit style={{ visibility: 'hidden' }} /> Show Contents
              </>
            )}
          </button>
          {contents}
        </aside>
      )}
      {showContentsSidebar && isMobile && (
        <>
          {!drawerOpen && (
            <div className="floating-contents-button">
              <button className="floating-contents-pill-button" onClick={() => setDrawerOpen(true)}>
                Show Contents
              </button>
            </div>
          )}
          {drawerOpen && (
            <Drawer title="Contents" onClose={() => setDrawerOpen(false)}>
              {contents}
            </Drawer>
          )}
        </>
      )}
      <div className="centered-content" aria-hidden={isMobile && drawerOpen ? "true" : "false"}>
        <section className="content-main" role="document">
          <GuideContentDisplay
            guide={guide}
            user={user}
            userInteraction={userInteraction}
            interactionLoading={interactionLoading}
            handleLike={handleLike}
            handleDislike={handleDislike}
            activeSection={activeSection}
            handleGuideContentsClick={handleGuideContentsClick}
            contentsVisible={contentsVisible}
            setContentsVisible={setContentsVisible}
            showContentsSidebar={showContentsSidebar}
            isAuthor={isAuthor}
            onEdit={handleEdit}
          />
          {guide.guide_id && (
            <div className="interaction-itinerary-section">
              {guide.itinerary_id && (
                <div className="itinerary-content">
                  <a href={`/itinerary/${guide.origin_id}/${guide.itinerary_id}`}>
                    View Itinerary
                  </a>
                </div>
              )}
            </div>
          )}
          {isAuthor && handleEdit && (
            <div className="guide-edit-button-container edit-button-bottom">
              <button className="guide-edit-button" onClick={handleEdit} title="Edit Guide">
                <FaEdit className="guide-edit-icon" /> Edit Guide
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
  )
}

export default GuideFullLayout
